import * as Yup from 'yup';
import moment from 'moment';
import { Regex, isDraftPrevious } from '../../../../shared/helpers';

const dateFormat = 'MM/DD/YYYY';

const validationSchema = (drafts, internalDrafts) =>
  Yup.object().shape(
    drafts
      .map(draft => ({
        [draft.name]: Yup.object().shape({
          url: urlValidation,
          due_date: dateValidation(draft, internalDrafts),
        }),
      }))
      .reduce((i, a) => ({ ...i, ...a })),
  );

const urlValidation = Yup.mixed().test(
  'is-valid-url',
  'please provide a valid url',
  url => {
    if (!url || url === '') return true;
    return url.match(Regex.site);
  },
);

const dateValidation = (draft, internalDrafts) =>
  Yup.mixed()
    .test('is-valid-day-month', 'please enter a valid date', value => {
      if (!value) return true;
      return moment(value, dateFormat).isValid();
    })
    .test('is-valid-day-month', 'please enter a date after today', value => {
      if (!value) return true;
      return moment(value, dateFormat).isAfter(moment());
    })
    .test(
      'is-valid-day-month',
      'please inform a date after the previous drafts',
      dueDate => {
        if (!dueDate) return true;

        const previousDraftsWithDateGreater = Object.entries(internalDrafts)
          .map(([, value]) => value)
          .filter(d => isDraftPrevious(d.name, draft.name))
          .filter(d =>
            moment(dueDate, dateFormat).isBefore(
              moment(d.due_date, dateFormat),
            ),
          );

        return !previousDraftsWithDateGreater.length > 0;
      },
    )
    .nullable();

export default validationSchema;



// WEBPACK FOOTER //
// ./src/components/ProjectView/DraftModal/DraftForm/validationSchema.js